export enum permissionType {
  Authenticated = 1,
  Users = 2,
  Accounts = 3,
  DeleteAccounts = 4,
  CreateAccounts = 5,
  ManageAssets = 6,
  ManageCustomerAccounts = 7,
  ManageCampuses = 8,
  ManageFacilities = 9,
  ManageWorkOrders = 10,
  ManageBlueprints = 11,
  ImportExportWorkOrders = 12,
  ImportAssets = 13,
  ManageFloors = 14,
  ManageProjects = 15,
}

export enum AssetProfileType {
  Door = 1,
  Damper = 2,
  AboveCeiling = 3,
  BelowCeiling = 4,
}

export enum FormFieldType {
  Label = 1,
  Checkbox = 2,
  RadioButton = 3,
  Dropdown = 4,
  Text = 5,
  SingleImage = 6,
  TextArea = 7,
  Date = 8,
  Facility = 9,
  FacilityContact = 10,
  Inspector = 11,
  DoorType = 12,
  DoorAction = 13,
  DoorMaterial = 14,
  DoorRating = 15,
  BarrierRating = 16,
  CommonId = 17,
  Floor = 18,
  Location = 19,
  PushSide = 20,
  PullSide = 21,
  DoorLabel = 22,
  FrameLabel = 23,
  MultiImage = 24,
  AssetNumber = 25,
  Campus = 26,
  DeficiencyId = 27,
  Blueprint = 28,
  InspectorPicker = 29,
  CategorySelect = 30,
  Multiselect = 31,
  FieldValue = 32,
  UserFieldValue = 33,
  ImageValue = 34,
  MultiImageValue = 35,
  CheckboxReadOnly = 36,
  RadioButtonReadOnly = 37,
  Assembly = 41,
  Mechanism = 42,
  AHUID = 43,
  SpecialConditions = 44,
}

export enum WorkOrderType {
  Inspection = 1,
  Repair = 2,
  SuggestedRepair = 3,
}

export enum ExportFileType {
  Excel = 1,
  PDF = 2,
}

export enum FieldRuleType {
  NotRequired = 1,
  Required = 2,
  Category = 3,
  DeficienciesDropdown = 4,
  WorkOrderStatus = 5,
  Prepopulated = 6,
  AccessProperty = 7,
  HideField = 8,
}

export enum WorkOrderStatus {
  Open = 1,
  Completed = 2,
  Canceled = 3,
  RepairedSuccessfully = 4,
  InScopeRepairSuccessful = 5,
  NotAbleToRepair = 6,
  RepairedNeedAdditionalRepairs = 7,
}
